<template>
  <tr style="height: 65px">
    <td>
      <yacht-chip
        :name="checklist.yacht.name"
        :image-path="checklist.yacht.model.main_image ? checklist.yacht.model.main_image.path : null"
      />
    </td>
    <td class="text-no-wrap">
      {{ checklist.check_in ? checklist.check_in.guest_name : '' }}
    </td>
    <td class="text-no-wrap caption grey--text text--darken-1 px-0">
      <div v-if="checklist.check_in">
        <v-chip
          v-if="checklist.check_in"
          small
          color="grey lighten-4 caption mr-1"
        >
          <v-avatar color="success">
            <v-icon
              small
              color="white"
            >
              check
            </v-icon>
          </v-avatar>
          {{ checklist.check_in.created_at | moment('D MMM YYYY HH:mm:ss') }}
        </v-chip>
        by {{ checklist.check_in.technician.name }}
      </div>
      <div
        v-else
        class="grey--text"
      >
        Pending
      </div>
    </td>
    <td class="text-no-wrap caption grey--text text--darken-1 px-0">
      <div v-if="checklist.check_out">
        <v-chip
          v-if="checklist.check_out"
          small
          color="grey lighten-4 caption mr-1"
        >
          <v-avatar color="success">
            <v-icon
              small
              color="white"
            >
              check
            </v-icon>
          </v-avatar>
          {{ checklist.check_out.created_at | moment('D MMM YYYY HH:mm:ss') }}
        </v-chip>
        by {{ checklist.check_out.technician.name }}
      </div>
      <div
        v-else
        class="grey--text"
      >
        Pending
      </div>
    </td>
  </tr>
</template>

<script>
  import YachtChip from '@/components/service/helpers/YachtChip'
  export default {
    name: 'ChecklistRow',
    components: { YachtChip },
    props: {
      checklist: {
        type: Object,
        required: true
      }
    }
  }
</script>
